/**
 * Canicule : heat-to-fresh hero scroll + zone shift + ATC pulse
 * Lightweight, respects prefers-reduced-motion
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrowMobile = window.matchMedia('(max-width: 749px)').matches;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initHeroHeatProgress() {
    var heroes = document.querySelectorAll('[data-canicule-hero-immersive]');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      if (reducedMotion || narrowMobile) {
        hero.style.setProperty('--heat-progress', '0.5');
        return;
      }

      function update() {
        var rect = hero.getBoundingClientRect();
        var viewH = window.innerHeight || 1;
        var scrollable = rect.height + viewH;
        var traveled = viewH - rect.top;
        var raw = traveled / scrollable;
        var progress = clamp(raw / 0.3, 0, 1);
        hero.style.setProperty('--heat-progress', String(progress));
      }

      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function initZoneShift() {
    var zones = document.querySelectorAll('[data-canicule-zone]');
    if (!zones.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('canicule-zone--active');
          }
        });
      },
      { rootMargin: '-10% 0px -60% 0px', threshold: 0.08 }
    );

    zones.forEach(function (zone) {
      observer.observe(zone);
    });
  }

  function initAtcPulse() {
    if (reducedMotion) return;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        if (!form.action || form.action.indexOf('/cart/add') === -1) return;

        var btn = form.querySelector('[type="submit"], .button[type="submit"]');
        if (!btn) return;

        btn.classList.add('canicule-atc--pulse');
        window.setTimeout(function () {
          btn.classList.remove('canicule-atc--pulse');
        }, 220);
      },
      true
    );
  }

  function initVariantFreshHalo() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('.variant-picker input, .variant-picker select')) return;

      var picker = input.closest('.variant-picker');
      if (!picker) return;

      picker.classList.add('canicule-variant--fresh');
      window.setTimeout(function () {
        picker.classList.remove('canicule-variant--fresh');
      }, 320);
    });
  }

  function init() {
    initHeroHeatProgress();
    initZoneShift();
    initAtcPulse();
    initVariantFreshHalo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
